export enum ArticlesActionType {
  FETCH_ARTICLES = 'FETCH_ARTICLES',
  FETCH_SELECTED_ARTICLE = 'FETCH_SELECTED_ARTICLE'
}
